import { ForgotPassword } from 'components/User';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {forgotPassword} from 'actions/user';
import {validateForgotPassword} from 'validations';

const mapDispatchToProps = (dispatch) => ({
  forgotPassword (user) {
    dispatch(forgotPassword(user.username));
  }
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'ForgotPassword',
  validate: validateForgotPassword
})(ForgotPassword));
